import { RiderSignature } from './rider-signature';
import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ReservationSignature extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserializeAs(RiderSignature)
  riderSignature: RiderSignature;

  @autoserialize
  dotsDriverSignatureDocumentId: number;

  @autoserialize
  riderSigned: boolean;

  @autoserialize
  riderRefusedSignature: boolean;

  @autoserialize
  riderUnableToSign: boolean;

  constructor() {
    super();

    this.riderSigned = false;
    this.riderRefusedSignature = false;
    this.riderUnableToSign = false;
  }
}
